import { stringify, parse } from 'qs'

export function addQueryParams (url, data) {
  return url + stringify(data, { addQueryPrefix: true, arrayFormat: 'brackets', format: 'RFC1738' })
}

export const getQueryParams = query => {
  const index = query.indexOf('#')
  if (index > 0) {
    query = query.substring(0, index)
  }
  return parse(query, { ignoreQueryPrefix: true, format: 'RFC1738' })
}

export const updateQueryParams = (option, type) => {
  let queryParams = {
    topic: null,
    area: null,
    year: null
  }

  if (option && type) {
    queryParams = {
      ...queryParams,
      ...getQueryParams(window.location.search),
      [type]: option && option.key
    }
  }

  const cleanedQueryParams = cleanObject(queryParams)

  const url = addQueryParams(window.location.origin + window.location.pathname, cleanedQueryParams)

  window.history.replaceState({
    path: url
  }, '', url)
}

export const clearQueryParams = () => {
  updateQueryParams()
}

export const triggerCustomEvent = (eventName, data) => {
  const event = new CustomEvent(eventName, { detail: data })
  window.dispatchEvent(event)
}

export function getQueryParamsForFilters (queryParamName, selectedFilters) {
  return selectedFilters
    .map(filter => filter.code)
    .reduce((params, filterCode) => {
      if (!params) params = ''
      params += `&${queryParamName}=${filterCode}`
      return params
    }, [''])
}

export function splitLabelTridion (labelTridion) {
  return labelTridion.split('{0}')
}

export const redirect = (url) => {
  global.UtilsBrowser.redirect(url)
}

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const isEmptyObject = (obj) => {
  const object = obj || {}

  return !Object.keys(object).length && object.constructor === Object
}

export const cleanObject = (obj) => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName]
    }
  }
  return obj
}

export const removeInvalidParams = (obj) => {
  for (const propName in obj) {
    if (!['area', 'topic', 'year'].includes(propName)) {
      delete obj[propName]
    }
  }
  return obj
}

export const scrollTop = () => {
  const landingElement = document.querySelector('.landing')
  if (!landingElement) return

  const bodyRect = document.body.getBoundingClientRect()
  const elemRect = landingElement.getBoundingClientRect()
  const offset = elemRect.top - bodyRect.top

  setTimeout(() => {
    window.scrollTo(0, offset)
  }, 1)
}

export const alphabeticalOrderDropdownOptions = (array) => {
  return array.sort((a, b) => {
    const nameA = a.name.toUpperCase()
    const nameB = b.name.toUpperCase()

    return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0
  })
}

export const alphabeticalReverseDropdownOptions = (array) => {
  return alphabeticalOrderDropdownOptions(array).reverse()
}
